const baseurl='/api'
const insertUser=baseurl+'/userController/insertUser'
const insertBuriedPoint=baseurl+'/buriedPointController/insertBuriedPoint'

export default{
	insertUser,
	insertBuriedPoint
}